import { render, staticRenderFns } from "./SettingComponent.vue?vue&type=template&id=1ce588fe&scoped=true&"
import script from "./SettingComponent.vue?vue&type=script&lang=js&"
export * from "./SettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingComponent.vue?vue&type=style&index=0&id=1ce588fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce588fe",
  null
  
)

export default component.exports